export default "__VITE_ASSET__Dvzmtdxt__"